// Lightweight browser notification helper (no external SaaS).
// Fires native OS notifications when the app is in another tab/window.
// For full push-when-tab-closed support, add a service worker + Web Push later.

const supported = typeof window !== "undefined" && "Notification" in window;

export function notificationState() {
  if (!supported) return "unsupported";
  return Notification.permission; // "default" | "granted" | "denied"
}

export async function requestNotificationPermission() {
  if (!supported) return "unsupported";
  if (Notification.permission === "default") {
    try {
      const result = await Notification.requestPermission();
      return result;
    } catch {
      return "denied";
    }
  }
  return Notification.permission;
}

let lastShownAt = 0;

export function showNotification(title, body, onClick) {
  if (!supported || Notification.permission !== "granted") return;
  // Throttle: max one notification per 2 seconds (avoid burst spam)
  const now = Date.now();
  if (now - lastShownAt < 2000) return;
  lastShownAt = now;
  // Skip when the tab is visible (don't double up with in-app toast)
  if (typeof document !== "undefined" && document.visibilityState === "visible") return;
  try {
    const n = new Notification(title, {
      body: body?.slice(0, 200),
      icon: "/favicon.ico",
      tag: "rendezvous",
      silent: false,
    });
    if (onClick) {
      n.onclick = () => {
        window.focus();
        try { n.close(); } catch (e) { console.warn("Notification close failed:", e); }
        onClick();
      };
    }
  } catch (e) {
    console.warn("Notification show failed:", e);
  }
}
